import { Node } from '@xanadu/model';
import { AspectMenu } from './aspect-menu';
import { Aspect } from '@xanadu/model';
import { Faction } from '@xanadu/model';
import { Branch } from '@xanadu/model';
import { Prototype } from '@xanadu/model';
import { MenuBuilder } from './menu-builder';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AspectMenuBuilder extends MenuBuilder {

    public Build(node: Node, clipboard?: Node): AspectMenu {
        const menu = new AspectMenu();
        if (node instanceof Faction) {
            this.forFaction(menu, node);
        } else if (node instanceof Prototype) {
            this.forPrototype(menu, node);
        } else if (node instanceof Aspect) {
            this.forAspect(menu, node);
        }

        this.forEdit(menu, node, clipboard);

        return menu;
    }

    private forFaction(menu: AspectMenu, node: Node): void {
        if (node.isNew) {
            return;
        }

        menu.faction = true;
        menu.aspect = true;
    }

    private forPrototype(menu: AspectMenu, node: Node): void {
    }

    private forAspect(menu: AspectMenu, node: Node): void {
    }

    private forEdit(menu: AspectMenu, node: Node, clipboard?: Node): void {
        var system  = node instanceof Prototype && node._system;

        menu.delete = !system && !!node.parentId && (!(node instanceof Branch) || !node.nodes?.length && !node.branches?.length);
        menu.cut = !system && !!node.parentId;
        menu.copy = !!node.parentId && !(node instanceof Faction);
        menu.paste = !!clipboard && !this.isChild(clipboard, node) && clipboard.fit(node as Branch) && !node.isNew;
    }

    private isChild(parent: Node, child: Node): boolean {
        return !parent || !child ?
        false : parent === child ?
        true : !child.parent ?
        false : this.isChild(parent, child.parent);
    }
}
